import {
    CurrentSong,
    ISongQueueEntry,
    SongQueue,
} from "@common-lib/classes/songQueue"
import { Store, StoreConfig, StoreConfigOptions } from "@datorama/akita"
import { cloneDeep } from "lodash"
import { v4 as uuidv4 } from "uuid"
import { PlaybackEngine } from "./playbackEngine"

export interface Song extends ISongQueueEntry {}

export interface CurrentSongAudioBuffer {
    start: number
    end: number
    buffer: ArrayBuffer | AudioBuffer
}

export interface PlayerState {
    volume: number
    bufferLoadingProgress: number
    status: "playing" | "paused"
    songQueue: SongQueue
    generatedSongCache: {
        [id: string]: CurrentSongAudioBuffer[]
    }
    songAudioCache: {
        [id: string]: {
            buffers: CurrentSongAudioBuffer[]
            lastAccessed: number
        }
    }
    playbackEngine: PlaybackEngine | undefined
    timeElapsed: number
    audioBufferForRMS: {
        endTime: number
        data: AudioBuffer | undefined // values are floats from 0 - 1
    }
}

export const initialState: PlayerState = {
    volume: 1,
    bufferLoadingProgress: 0,
    status: "paused",
    songQueue: new SongQueue(),
    songAudioCache: {},
    generatedSongCache: {},
    playbackEngine: undefined,
    timeElapsed: 0,
    audioBufferForRMS: { data: undefined, endTime: 0 },
}

@StoreConfig({ name: "Player" })
export class PlayerStore extends Store<PlayerState> {
    protected options: Partial<StoreConfigOptions>

    constructor() {
        super(cloneDeep(initialState))
    }

    public updateStore(partial: Partial<PlayerState>) {
        this.update(state => ({
            ...state,
            ...partial,
            lastUpdate: Date.now(),
        }))
    }
}
